module.exports = __webpack_public_path__ + "b2544e0d93302bbd6a72aadba52871d6.pdf";